export const handleError = (dispatch, err) => {
  if (err && err.response && err.response.status === 401) {
    dispatch({
      type: 'LOGOUT',
    });
  } else {
    dispatch({
      type: 'API_ERROR',
    });
  }
};

export const showNotification =
  ({ message, type }) =>
    (dispatch) =>
      dispatch({
        type: 'SHOW_NOTIFICATION',
        payload: { message, type },
      });

export const showNotificationDispatch = (dispatch, { message, type }) => {
  dispatch({
    type: 'SHOW_NOTIFICATION',
    payload: { message, type },
  });
};
